import deviceFingerprint from "src/shared/utilities/deviceFingerprint";

import analytics from "../analytics";
import useContactListingAgentMutation from "./useContactListingAgentMutation";
import useFeatureState from "./useFeatureState";

const useContactListingAgent = () => {
  const { expertsApiUuid, messageScreeningFlag } = useFeatureState();
  const [contactListingAgent] = useContactListingAgentMutation();

  return async formValues => {
    try {
      const { body, email, listing_id, name, phone, subject } = formValues;

      const {
        data: { contact_sale_listing_agent = {} } = {}
      } = await contactListingAgent({
        variables: {
          input: {
            device_fingerprint: deviceFingerprint(),
            message_details: {
              email_content: body,
              email_subject: subject,
              experts_api_uuid: expertsApiUuid,
              origin_label: "experts_hdp_listing_agent_redirect",
              sender_email: email,
              sender_name: name,
              sender_phone: phone
            },
            sale_id: listing_id
          }
        }
      });

      if (contact_sale_listing_agent.errors) {
        throw contact_sale_listing_agent.errors;
      }

      analytics({
        action: "contact",
        isHdp: true,
        label: `uuid=${expertsApiUuid}|type=experts_hdp_listing_agent_redirect|flag=${messageScreeningFlag}`
      });

      return {};
    } catch (error) {
      return { error };
    }
  };
};

export default useContactListingAgent;
